import { Check } from '@project-lary/react-material-symbols';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import type * as React from 'react';
import { cn } from '../utils/tailwind-merge';

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        className,
        'peer size-6 shrink-0 rounded-[4px] border border-input shadow-xs outline outline-2 outline-secondary transition-shadow focus:outline focus:outline-2 focus:outline-secondary disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-secondary data-[state=checked]:bg-secondary data-[state=checked]:text-primary dark:bg-input/30 dark:data-[state=checked]:bg-secondary dark:aria-invalid:ring-destructive/40',
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <Check className="size-7" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
